export { validate } from 'email-validator'
export const canonicalize = (email: string) => {
  if (!email) throw new Error(`Email address may not be empty`)
  return email.toLowerCase().trim()
}
